import type { ColumnConfig, ConfigTableProps } from '@/components/datatable/dataTableTypes';
import { makeNumberFormatter } from '@/utils/dataTable';

export const columns: ColumnConfig[] = [
  { field: 'id', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'partnerName' },
  { field: 'amount', type: 'number', align: 'right', formatter: makeNumberFormatter() },
  { field: 'currency' },
  { field: 'paymentType', type: 'enum' },
];

export const tableConfig: ConfigTableProps = {};
